module.exports = __webpack_public_path__ + "img/space-hand-left.5a12d1d9.png";